/* Polsk katalog for locale-bank-archive-filter-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'bank.archive.filter.postingType': 'Typ księgowania',
  'bank.archive.filter.purchase': 'Zakup',
  'bank.archive.filter.otherSale': 'Inna sprzedaż',
  'bank.archive.filter.payment': 'Płatność',
  'bank.archive.filter.manualPosting': 'Księgowanie ręczne',
  'bank.archive.filter.bankPosting': 'Księgowanie bankowe',
  'bank.archive.filter.publicPayment': 'Płace i podatki',
  'bank.archive.filter.ignored': 'Zignorowana pozycja bankowa',
  'bank.archive.filter.documentation': 'Dokumentacja',
  'bank.archive.filter.missingAttachment': 'Brak dowodu księgowego',
  'bank.archive.filter.hasAttachment': 'Z dowodem księgowym',
  'bank.archive.sort.label': 'Sortuj księgowania',
  'bank.archive.sort.statementOrder': 'Kolejność z wyciągu bankowego',
  'bank.archive.sort.dateDesc': 'Data: od najnowszych',
  'bank.archive.sort.dateAsc': 'Data: od najstarszych',
  'bank.archive.sort.amountDesc': 'Kwota: od najwyższej',
  'bank.archive.sort.amountAsc': 'Kwota: od najniższej',
});
